import { StatusMsg } from "utils";

const chalk = require("chalk");

interface LogOptions {
  message: string;
  status?: StatusMsg;
  error?: unknown;
}

export class AppLog {
  static show({ message, status = StatusMsg.info, error }: LogOptions): void {
    switch (status) {
      case StatusMsg.error:
        if (error) {
          if (error instanceof Error) {
            console.log(AppLog.error(`${message} : ${error.message}`));
            console.log(AppLog.error(`Stack trace: ${error.stack}`));
          } else {
            console.error("[Log Error] :", error);
          }
        }
        break;
      case StatusMsg.info:
        console.log(AppLog.info(message));
        break;
      case StatusMsg.success:
        console.log(AppLog.success(message));
        break;
      case StatusMsg.warning:
        if (error) {
          if (error instanceof Error) {
            console.log(AppLog.warning(`${message} : ${error.message}`));
            console.log(AppLog.error(`Stack trace: ${error.stack}`));
          } else {
            console.error("[Log Error] :", error);
          }
        }
        break;
      default:
        console.log(AppLog.info(message));

        if (error instanceof Error) {
          console.log(AppLog.error(`${message} : ${error.message}`));
          console.log(AppLog.error(`Stack trace: ${error.stack}`));
        } else {
          console.error("[Log Error] :", error);
        }
        break;
    }
  }

  static log(message: string): void {
    console.log(chalk.magenta(`[LOG]: ${message}`));
  }

  private static error(message: string): string {
    return chalk.red(`[ERROR]: ${message}`);
  }

  private static warning(message: string): string {
    return chalk.yellow(`[WARNING]: ${message}`);
  }

  private static info(message: string): string {
    return chalk.blue(`[INFO]: ${message}`);
  }

  private static success(message: string): string {
    return chalk.green(`[SUCCESS]: ${message}`);
  }
}

